import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  btn: {
    height: 48,
    textTransform: 'none',
    margin: spacing(1, 0, 4)
  }
}))
